import { render, staticRenderFns } from "./cardSuperCedis.vue?vue&type=template&id=147689ae&scoped=true&"
import script from "./cardSuperCedis.vue?vue&type=script&lang=js&"
export * from "./cardSuperCedis.vue?vue&type=script&lang=js&"
import style0 from "./cardSuperCedis.vue?vue&type=style&index=0&id=147689ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147689ae",
  null
  
)

export default component.exports